
import React from 'react';
import { Clock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { formatTime } from '../../utils/timeUtils';

interface WeeklySummaryProps {
  weekTotal: number;
  weekData: Array<{ totalMinutes: number }>;
}

export const WeeklySummary: React.FC<WeeklySummaryProps> = ({ weekTotal, weekData }) => {
  const workedDays = weekData.filter(day => day.totalMinutes > 0).length;
  const avgPerDay = workedDays > 0 ? Math.round(weekTotal / workedDays) : 0;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="h-5 w-5" />
          Résumé de ma semaine
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
          <div>
            <div className="text-2xl font-bold text-blue-600">{formatTime(weekTotal * 60000)}</div>
            <div className="text-sm text-muted-foreground">Total de ma semaine</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-green-600">
              {Math.round(weekTotal / 60 * 100) / 100}
            </div>
            <div className="text-sm text-muted-foreground">Heures décimales</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-orange-600">
              {workedDays}
            </div>
            <div className="text-sm text-muted-foreground">Jours travaillés</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-purple-600">
              {avgPerDay}m
            </div>
            <div className="text-sm text-muted-foreground">Moyenne par jour</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
